export default class Pick {
    constructor(scene, pickSpine, pickText, debugGraphics) {
        this.isPicked = false;
        this.pickSpine = pickSpine;
        this.pickText = pickText;
        this.debugGraphics = debugGraphics;
        this.pickContainer = scene.add.container(pickSpine.x, pickSpine.y, [pickSpine, pickText, debugGraphics]);
    }
    getPickSpine() {
        return this.pickSpine;
    }
    getPickText() {
        return this.pickText;
    }
    getPickContainer() {
        return this.pickContainer;
    }
    getIsPicked() {
        return this.isPicked;
    }
    setIsPicked(isPicked) {
        this.isPicked = isPicked;
    }
    getDebugGraphics() {
        return this.debugGraphics;
    }
    setDebugGraphics(debugGraphics) {
        this.debugGraphics = debugGraphics;
    }
}
